var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBt = function SvgBt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M3.514 20.485c-4.687-4.686-4.687-12.284 0-16.97 4.686-4.686 12.284-4.686 16.97 0 0 .001 3.186 10.784-1.5 15.47-4.686 4.687-15.467 1.504-15.47 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M3.515 20.485c4.686 4.686 12.284 4.686 16.97 0 4.687-4.687 4.687-12.285 0-16.971l-16.97 16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M18.789 6.782V4.695h-4l-.306.306c-1.087 1.087-.904 2.355-.77 3.28.123.86.138 1.188-.181 1.508-.32.32-.649.304-1.508.18-.926-.133-2.194-.316-3.28.771-1.088 1.087-.905 2.355-.771 3.28.124.86.139 1.189-.18 1.508-.32.32-.649.304-1.508.18a7.846 7.846 0 0 0-1.05-.102l-.023 2.087c.231.002.496.04.775.081a7.61 7.61 0 0 0 1.102.102c.409 0 .84-.058 1.265-.242v1.67h3.13v-1.566H9.92v-1.043h1.043V15.13h-.833c.04-.507-.03-.991-.09-1.407-.124-.859-.14-1.188.18-1.507.32-.32.648-.305 1.507-.18.675.096 1.531.22 2.367-.141v1.67h3.13v-1.566h-1.565v-1.043h1.044V9.39h-.834c.04-.507-.03-.992-.09-1.407-.087-.6-.12-.942-.023-1.202h3.034Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBt;